type CheckoutIntentSource = {
  creditPackages: ReadonlyArray<{ checkoutIntentKey: string }>;
  plans: ReadonlyArray<{
    billingOptions: ReadonlyArray<{ checkoutIntentKey: string }>;
  }>;
};

export function collectSiteRuntimeCheckoutIntentKeys(
  source: CheckoutIntentSource
) {
  return Array.from(
    new Set([
      ...source.plans.flatMap((plan) =>
        plan.billingOptions.map((option) => option.checkoutIntentKey)
      ),
      ...source.creditPackages.map(
        (creditPackage) => creditPackage.checkoutIntentKey
      ),
    ])
  );
}
